import { useIntl } from 'react-intl';

import type { Currency } from '../../../../prop-types/currency-types';

import { CustomsField } from '../customs-field';
import { TotalValueDisplay } from './total-value-display';

import messages from '../messages';

type CustomsTotalProps = {
  declaredAmount: Currency;
  quantity: number;
};

export const CustomsTotal: React.FC<CustomsTotalProps> = ({ declaredAmount, quantity }) => {
  const intl = useIntl();

  return (
    <CustomsField label={messages.totalValueLabel}>
      <TotalValueDisplay aria-label={intl.formatMessage(messages.totalValueLabel)} declaredAmount={declaredAmount} quantity={quantity} />
    </CustomsField>
  );
};
